import { Rect } from 'react-konva';
import React, { memo } from 'react';

type ImageGridProps = {
  width: number;
  height: number;
  zoom?: number;
};

export const ImageGrid = memo(({ width, height, zoom = 1 }: ImageGridProps) => {
  // Базовый размер ячейки, который будет масштабироваться с зумом
  const baseCellSize = 50;
  const cellSize = baseCellSize * zoom;
  const cellSizeLarge = cellSize * 5;

  const gridLines = [];

  // Вертикальные линии
  for (let i = -width / 2; i <= width / 2; i += cellSize) {
    gridLines.push(
      <Rect
        key={`vertical-${i}`}
        x={i}
        y={-height / 2}
        width={1}
        height={height}
        fill="rgba(69, 90, 100, 0.40)"
      />
    );
  }

  // Горизонтальные линии
  for (let i = -height / 2; i <= height / 2; i += cellSize) {
    gridLines.push(
      <Rect
        key={`horizontal-${i}`}
        x={-width / 2}
        y={i}
        width={width}
        height={1}
        fill="rgba(69, 90, 100, 0.40)"
      />
    );
  }

  // Крупные вертикальные линии
  for (let i = -width / 2; i <= width / 2; i += cellSizeLarge) {
    gridLines.push(
      <Rect
        key={`vertical-large-${i}`}
        x={i}
        y={-height / 2}
        width={2}
        height={height}
        fill="rgba(69, 90, 100, 0.80)"
      />
    );
  }

  // Крупные горизонтальные линии
  for (let i = -height / 2; i <= height / 2; i += cellSizeLarge) {
    gridLines.push(
      <Rect
        key={`horizontal-large-${i}`}
        x={-width / 2}
        y={i}
        width={width}
        height={2}
        fill="rgba(69, 90, 100, 0.80)"
      />
    );
  }

  return <>{gridLines}</>;
});

ImageGrid.displayName = 'ImageGrid'; 